var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplinterTurret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90.6926 9.77105L89.5555 8.26805L89.0921 7.72205L90.0671 6.72455L88.6301 5.91905L89.1536 4.72355L86.0981 2.36255L84.8816 1.86005L85.1981 3.63605L85.6106 5.06405L82.1231 4.95605L80.5526 5.23955L63.6326 5.28305L63.4001 4.76855L62.9816 3.84155L61.8266 2.66555H59.7685C59.7685 2.66555 59.617 3.77855 59.506 3.85805C59.3965 3.93605 59.0695 4.36505 59.023 4.52255C58.975 4.68005 57.9566 4.11455 57.9566 4.11455L54.8006 3.63605L53.2226 4.01105L53.6396 5.21705L55.4486 5.61455L53.44 6.51005L52.0091 6.06905L51.6296 5.05805L50.8091 4.38155L42.5605 4.77155L39.0236 5.26355L38.0036 4.93805L36.847 5.44505L34.1396 6.50855H33.1915C33.1915 6.50855 32.743 5.91155 32.6215 5.61305C32.5 5.31455 31.276 4.38155 31.276 4.38155L30.046 5.41505L30.58 6.51005C30.58 6.51005 30.088 8.33855 30.046 8.59055C30.004 8.84255 29.9771 10.971 29.9771 10.971L31.8731 12.0105L33.364 12.423L35.5901 13.569L39.349 13.3395L40.138 13.017L42.04 13.059L44.107 14.172L47.1445 14.6835L49.7861 14.607L50.8105 14.265L51.739 13.971L53.0365 13.5795L56.0306 13.971L57.3865 13.5855L57.6626 17.187L56.9351 17.283C56.9351 17.283 55.7756 16.2285 55.5896 16.2285C55.4036 16.2285 54.4961 16.1145 54.4961 16.1145L53.9816 15.5475C53.9816 15.5475 52.4816 15.5475 52.2371 15.702C51.9926 15.8565 52.2371 18.8565 52.2371 18.8565L53.3111 21.9645L52.3466 30.549L51.322 31.1355L51.5081 32.1255L52.5101 32.8065L53.674 38.0715L59.1775 42.7665L59.641 44.2365C59.641 44.2365 58.3376 44.1375 53.4251 43.6635C48.5126 43.1895 44.3831 45.7065 44.3831 45.7065L43.6285 46.896L40.6496 47.0865L41.3921 48.4545H43.039L45.8081 50.1885C45.8081 50.1885 48.976 51.0855 52.8535 51.4695C56.731 51.8535 60.7735 50.2965 61.9525 49.749C63.1315 49.2015 63.5051 48.7845 63.5051 48.7845L63.9806 49.2015L63.8801 50.748C63.8801 50.748 61.6691 52.542 56.347 53.4465C51.025 54.351 47.3006 52.728 47.3006 52.728L46.372 53.0985L43.3706 52.362L37.834 52.2315L37.1531 53.283L37.447 55.0215L42.6595 55.1385L48.9445 56.6085L49.8326 57.342C49.8326 57.342 51.5036 57.615 52.8056 57.657C54.1076 57.699 57.2201 57.609 59.1131 57.4215C61.0061 57.2355 62.6111 56.562 62.6111 56.562L63.8785 54.6435H64.4966L65.9576 54.2565L67.198 53.01L68.0861 51.4665L68.8105 51.3645L69.8591 51.9945L70.8806 52.329L71.7341 51.426L72.8501 51.6915L71.5481 48.8895L68.2076 47.034H67.1561L65.7086 44.6835L64.3721 40.7865L62.7011 39.24L61.8236 30.549V28.971L61.0916 22.8465L59.7656 22.5825L59.5435 20.4645L60.2876 19.8765L61.6211 20.4645L62.4251 19.923L62.9171 19.2765L63.799 19.629H65.0831L71.7461 16.6095L71.5481 15.546L60.7826 17.0355L59.6381 18.0045L59.5046 14.262L61.6226 14.196L62.8721 14.6805L64.7275 14.538C64.7275 14.538 72.0355 13.1205 72.1525 13.0095C72.268 12.897 74.566 13.0095 74.566 13.0095L76.7006 12.1095L82.036 11.526L83.3351 12.1095L89.5526 11.9355L91.27 11.2005L90.6895 9.77105H90.6926ZM37.738 8.29955L36.5665 9.15755L35.4356 8.92805V7.88405C35.4356 7.88405 36.9071 6.93155 37.4021 6.72305C37.8971 6.51455 38.3621 6.79205 38.4386 7.30355C38.5151 7.81505 37.738 8.29955 37.738 8.29955V8.29955ZM56.9201 48.9555C55.9616 49.11 51.1661 49.272 50.2691 49.068C49.3721 48.864 48.1031 48.0585 48.1031 48.0585C48.1031 48.0585 49.4336 47.409 50.7326 47.4405C52.0316 47.472 52.2371 47.568 52.2371 47.568L56.2076 47.595L58.9301 48.456C58.9301 48.456 57.877 48.801 56.9185 48.9555H56.9201ZM59.641 26.3205L60.4466 34.3095L59.2406 33.273C59.2406 33.273 58.5911 31.077 58.6226 30.984C58.6541 30.891 58.9331 30.3 58.9331 30.3L58.5296 29.0985L58.591 27.4275L59.6426 26.322L59.641 26.3205ZM81.2186 9.77855C81.2651 10.104 80.1356 10.8 80.1356 10.8C80.1356 10.8 79.1141 11.1705 78.1256 11.1255C77.1356 11.079 76.1921 10.6455 76.1921 10.6455L76.4081 9.08405C76.4696 9.06905 81.2336 9.08405 81.2336 9.08405C81.2336 9.08405 81.1721 9.45455 81.2186 9.78005V9.77855Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2505 25.3831C58.7277 25.3831 59.1145 24.9963 59.1145 24.5191C59.1145 24.0419 58.7277 23.6551 58.2505 23.6551C57.7733 23.6551 57.3865 24.0419 57.3865 24.5191C57.3865 24.9963 57.7733 25.3831 58.2505 25.3831Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4978 16.1145L56.3338 19.848L56.0548 22.044L56.6728 25.8795C56.6728 25.8795 57.1678 26.622 57.1993 27.117C57.2308 27.612 55.3438 30.396 55.3438 30.396L56.0548 35.16L65.0428 42.735",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.323 35.3985L60.463 42.0105H61.8085L65.9605 45.027",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5878 46.767L68.2813 51.369",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7704 34.3095L60.2924 38.439",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0479 10.2975L30.8129 9.771H32.7388L33.6674 10.5285L40.6274 10.7145L41.8559 10.389L45.4288 10.2975",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3633 12.09H40.2553L42.5638 13.338",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3719 11.4749H44.7789C44.7789 11.4749 44.0829 12.5804 44.9874 12.7139C45.8919 12.8489 48.8619 12.7139 48.8619 12.7139V14.2634",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1793 7.95001L65.1493 11.0625L68.1193 11.202L68.8153 10.599L76.2823 10.8315",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0554 9.77106L63.8034 14.4496",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6622 13.3831L56.8432 13.9861L54.9412 14.0326L54.4312 13.6156L52.5757 13.5691L52.1122 14.0791H50.5807L50.1172 14.6836L48.9112 14.4046L48.1222 14.6836H45.0592L42.0427 13.0591L39.9082 13.0126L39.4447 13.4296L35.5942 13.5691L33.5992 12.4096L32.8102 12.4561C32.8102 12.4561 30.1192 11.2036 29.9797 10.9711C29.8402 10.7386 29.9797 9.85805 29.9797 9.85805C29.9797 9.85805 29.9332 8.55905 30.2587 7.72355C30.5842 6.88805 30.9547 6.51755 30.6292 6.09905C30.3037 5.68205 29.9182 5.49605 29.9182 5.49605L31.2787 4.66055C31.2787 4.66055 32.2072 5.35655 32.5777 5.72705C32.9482 6.09755 33.4132 6.84005 33.4132 6.84005L33.9697 6.42305L34.4332 6.65555C34.4332 6.65555 34.8037 6.28505 35.4547 5.95955C36.1042 5.63405 36.5677 5.54255 36.9862 5.40305C37.4032 5.26355 37.6357 4.89305 38.0077 4.93955C38.3797 4.98605 38.5642 5.26505 38.5642 5.26505H39.3532L39.7702 4.93955L48.3082 4.42955C48.3082 4.42955 49.2367 4.33655 50.1637 4.42955C51.0907 4.52255 51.6952 4.89305 51.6952 5.26505V6.05405C51.6952 6.05405 52.6702 6.05405 52.8547 6.37955C53.0392 6.70505 54.8032 6.42605 54.8032 6.42605L56.9377 5.61605L55.2667 5.17205C55.2667 5.17205 54.3847 5.45105 53.6422 5.21855C52.8997 4.98605 53.0392 4.15205 53.2252 4.01255C53.4112 3.87305 53.5507 3.50255 54.4777 3.68705C55.4062 3.87305 58.7932 4.19705 58.7932 4.19705L61.1137 5.58905L63.9907 5.23805H81.1117L81.9007 4.93805L86.3092 5.23805V6.19205L90.0682 6.56255V7.30505L89.0932 7.72205L89.5567 8.55755H90.0667C90.0667 8.55755 90.5572 8.98955 90.6937 9.77255C90.8797 10.8391 90.1837 11.4766 90.1837 11.4766C90.1837 11.4766 90.6247 10.9711 91.7842 10.8316C92.9437 10.6921 93.5017 10.5841 93.6862 10.8931C93.8722 11.2021 93.6397 11.5276 92.2942 11.7586C90.9487 11.9911 83.1532 12.0841 83.1532 12.0841L82.0402 11.5276L76.4722 12.2701L74.9407 13.0126H72.5737C72.5737 13.0126 64.4542 14.7301 63.5257 14.6836C62.5972 14.6371 62.2732 14.6836 62.2732 14.6836L61.9522 14.1721L60.2317 14.3116L59.4277 13.5376",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4264 19.2991L59.7969 22.8481H61.0959L61.9509 29.3446L61.8279 30.0871L62.7054 39.2431L64.3764 40.7896L65.8614 45.1201L67.1604 47.0386H68.2119L71.5524 48.8941L73.0374 51.7396L71.7384 51.4306L70.9344 52.0486L70.6869 53.4721L69.5109 51.3691H68.0874C68.0874 51.3691 68.3349 52.6066 65.1174 54.6481H63.8799L62.6109 56.5666C62.6109 56.5666 60.7854 57.3091 58.0014 57.5566C55.2174 57.8041 50.9484 57.6181 50.4534 57.5566C49.9584 57.4951 49.6494 57.3091 49.4634 56.8756C49.2774 56.4421 42.6579 55.1431 42.6579 55.1431L37.1514 55.0201V53.2876L37.8324 52.2361L43.0914 52.2976L46.3704 53.1016L47.2989 52.7311C47.2989 52.7311 51.3204 54.1546 56.6409 53.4121C61.9614 52.6696 63.8799 50.7511 63.8799 50.7511L64.0029 48.8326L62.7654 47.3476L60.9714 46.3576L59.1774 42.7696L53.9799 38.3776C53.9799 38.3776 53.1759 37.8226 53.1759 36.6151C53.1759 35.4076 52.8054 33.0571 52.8054 33.0571L52.0629 32.4391L51.2589 32.3161L51.3204 31.1401L52.3104 30.8311L53.1144 24.5206C53.1144 24.5206 53.3619 22.2316 53.3004 21.7981C53.2389 21.3646 52.1874 19.5091 52.1874 19.5091V15.5491H53.9814L54.5994 16.2301H55.7754L57.1359 17.4676H57.5844",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.024 26.715L58.622 27.2715C58.622 27.2715 58.406 27.3645 58.406 28.0755V29.1585L58.529 29.004L58.9625 30.396L58.5605 30.8595C58.5605 30.8595 58.499 32.2515 58.6535 32.808C58.808 33.3645 60.602 34.788 60.602 34.788L59.9525 26.343C59.9525 26.343 59.426 26.157 59.024 26.7135V26.715Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3781 9.15906H81.1106C81.1106 9.15906 81.3896 9.71706 81.1106 10.2286C80.8316 10.7386 77.4446 11.2036 77.3051 11.2036C77.1656 11.2036 75.3101 11.1541 76.3766 9.16056L76.3781 9.15906Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7767 9.04366H36.8207L38.4212 7.74466C38.4212 7.74466 38.5832 6.84016 38.0507 6.74716C37.5182 6.65416 37.1117 6.86266 37.1117 6.86266L35.6612 7.88266C35.6612 7.88266 35.0807 8.37016 35.7767 9.04366V9.04366Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4244 49.2031C57.2169 49.2031 60.2914 48.3723 60.2914 47.3476C60.2914 46.3228 57.2169 45.4921 53.4244 45.4921C49.6318 45.4921 46.5574 46.3228 46.5574 47.3476C46.5574 48.3723 49.6318 49.2031 53.4244 49.2031Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5046 48.3466C62.5536 50.1286 58.4031 51.4711 53.4261 51.4711C47.7471 51.4711 43.1421 49.7236 43.1421 47.5681",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3828 45.708C46.1243 44.4915 49.5203 43.665 53.4248 43.665C55.9688 43.665 58.2968 44.016 60.0923 44.5965",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 46.0949C44.2 45.5654 45.2904 45.0284 46.1139 45.0284C47.1474 45.0284 47.8029 45.9254 47.8029 46.2839",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1404 47.568C43.1404 47.0385 43.9054 46.6095 44.8489 46.6095C45.7924 46.6095 46.4359 46.9605 46.6054 47.568",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9343 48.2055C47.9343 48.2055 48.7578 47.343 52.0293 47.3535L52.4463 47.7825C52.4463 47.5125 57.3498 47.319 59.4138 48.255",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0388 48.456H41.0678L40.8818 47.088H43.3703",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.262 18.0539L60.6025 20.4674L62.1175 20.2514C62.1175 20.2514 62.149 19.2615 62.7355 19.2615C63.322 19.2615 63.787 19.8179 63.787 19.8179L65.086 19.632L71.7985 16.8794L71.551 15.549L60.601 17.064L60.2605 18.0539H60.262Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0706 1.56604L89.1536 4.72054C89.1536 4.72054 89.3396 5.27704 89.1536 5.58604C88.9676 5.89504 87.9776 6.11254 87.9776 6.11254L86.9876 5.74204L85.7186 4.56604C85.7186 4.56604 84.8831 3.17404 84.7601 2.61754C84.6371 2.06104 85.0691 1.56604 85.0691 1.56604H85.0706Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6169 4.69052V2.43152H61.3134L62.9829 3.84002L63.6339 5.28002",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6621 13.3831V11.4646L57.9711 10.8151V7.47456C57.9711 7.47456 58.0026 6.60906 58.5276 6.51606C59.0526 6.42306 59.1456 7.35156 59.1456 7.44456V10.7551L59.4246 11.3731V20.6836C59.4246 20.6836 59.0226 21.3331 58.5426 21.4261C58.0626 21.5191 57.6606 20.6836 57.6606 20.6836V13.3831",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0648 6.50842L51.7383 7.02592L50.8113 7.58242L53.6403 9.39142H56.0733",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5076 7.53455C60.4181 7.91255 61.0571 8.80955 61.0571 9.85655C61.0571 10.77 60.5696 11.5695 59.8406 12.0105",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3921 12.09C56.5836 11.673 56.0302 10.8285 56.0302 9.85503C56.0302 8.66853 56.8522 7.67553 57.9562 7.41003",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4217 11.2021H53.0152C53.0152 11.2021 51.9712 9.94957 53.6422 9.39307",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9507 14.1705L60.4657 11.475",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3503 5.26204L39.5978 6.50853C39.5978 6.50853 40.9583 6.01953 41.7323 6.94803C42.5063 7.87653 43.2473 8.71053 43.2473 8.71053L44.0828 9.04353L46.3718 11.475H51.1973L52.6928 10.506V9.94953L47.7638 9.77253L46.4333 8.71203L46.4948 7.41153L51.3518 5.06104",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9362 5.61301C56.9362 5.61301 59.3947 4.38151 61.1122 5.58751",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0818 7.86905H64.1588L66.0308 6.97955H69.9743L70.9028 7.41155H81.3578L82.3778 7.86905H84.6593L85.5653 8.69555L89.5553 8.55755",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2609 8.67151C86.2609 8.67151 87.2329 10.173 86.0974 12.033",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplinterTurret);
export default __webpack_public_path__ + "static/media/Splinter Turret.a386e9438378b809dbc1c0e2860c49af.svg";
export { ForwardRef as ReactComponent };